import React from "react";
import { arrayOf, exact, number, shape, string } from "prop-types";
import { Card } from "uikit/components";
import styles from "./SchoolGroupsAttendanceView.module.styl";
import SchoolGroupsAttendanceRow from "components/schoolSummary/SchoolGroupsAttendanceRow/SchoolGroupsAttendanceRow";

export default function SchoolGroupsAttendanceView({ groupsAttendance, sportOrgUrl, schoolId }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <div className={styles.headingContainer} data-test-name="school_attendance_view">
                <div className={styles.groupCode}>Код группы</div>
                <div className={styles.sportType}>Вид спорта</div>
                <div className={styles.sportTraining}>Этап подготовки - Год подготовки</div>
                <div className={styles.coachName}>Тренер</div>
                <div className={styles.attendancePercent}>Посещаемость за прошлую неделю</div>
            </div>
            <div>
                {groupsAttendance?.map((item) => (
                    <SchoolGroupsAttendanceRow
                        key={item.groupId}
                        groupAttendance={item}
                        sportOrgUrl={sportOrgUrl}
                        schoolId={schoolId}
                    />
                )) ?? []}
            </div>
        </Card>
    );
}

SchoolGroupsAttendanceView.propTypes = {
    groupsAttendance: arrayOf(
        shape({
            groupId: number.isRequired,
            groupCode: string.isRequired,
            sportType: string.isRequired,
            sportTrainingLevel: string,
            sportTrainingYear: number.isRequired,
            coachName: exact({
                lastName: string.isRequired,
                firstName: string.isRequired,
                middleName: string,
                shortName: string.isRequired,
                fullName: string.isRequired,
                officialShortName: string.isRequired,
                officialFullName: string.isRequired,
                lastNameAndInitials: string.isRequired,
                firstNameAndMiddleName: string.isRequired,
            }),
            attendancePercent: number.isRequired,
        }),
    ),
    sportOrgUrl: string.isRequired,
    schoolId: number.isRequired,
};
